import styles from './GroupControl.module.scss.js';
import cx from 'classnames';
import { jsx } from 'react/jsx-runtime';

const GroupControl = ({
  groupControlType = "filled",
  items,
  selected,
  setSelected,
  setSelectedIndex,
  className,
  dataTestId = "group-control",
  hidden = false
}) => /* @__PURE__ */ jsx("div", {
  className: cx(styles.groupControl, styles[`${groupControlType}GroupControl`], className),
  "data-test-id": dataTestId,
  hidden,
  children: items.map((item, index) => /* @__PURE__ */ jsx("button", {
    className: cx({
      [styles.selected]: selected === item
    }),
    onClick: () => {
      setSelected(item);
      setSelectedIndex?.(index);
    },
    children: item
  }, `group-item-${index}`))
});

export { GroupControl as default };
//# sourceMappingURL=GroupControl.js.map
